import { render, staticRenderFns } from "./fundRecordList.vue?vue&type=template&id=16e0aaac"
import script from "./fundRecordList.vue?vue&type=script&lang=js"
export * from "./fundRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports